let baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const isDevelopment = process.env.NODE_ENV === 'development';

let apiBaseUrl = '{VUE_APP_API_BASE_URL}';

if (isDevelopment) {
  apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
  baseUrl = '~/web';
}

export default {
  baseUrl,
  apiBaseUrl,
};
